import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var WarningIconV2 = function WarningIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 14.3684H11.0909V9.63158H12.9091V14.3684ZM12.9091 18.1579H11.0909V16.2632H12.9091V18.1579ZM2 21H22L12 3L2 21Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon)
  })));
};
WarningIconV2.propTypes = {
  iconColor: PropTypes.string
};
WarningIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WarningIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var WarningIconV2$1 = withTheme(WarningIconV2);

export default WarningIconV2$1;
